import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { HeaderComponent, HeaderLogoComponent, HeaderLogoMiniComponent,HeaderUserComponent } from './header.component';


@NgModule({
    imports: [CommonModule, RouterModule ],
    exports: [HeaderComponent, HeaderLogoComponent, HeaderLogoMiniComponent,HeaderUserComponent],
    declarations: [HeaderComponent, HeaderLogoComponent, HeaderLogoMiniComponent,HeaderUserComponent]
})
export class HeaderModule { }
